import React from "react";

const ProductSelectorButton = ({ additionalClasses = "", ...props }) => {
  const { show_product_picker_v2, show_bundle_design } = window?.productData || {};
  const baseClasses = show_bundle_design
    ? "productPackages__button"
    : show_product_picker_v2
      ? "productPackages_v2__button"
      : "productPackages__button";
  const combinedClasses = `${baseClasses} ${additionalClasses}`.trim();

  return <button data-cy="product-selector" className={combinedClasses} type="button" {...props} />;
};

export default ProductSelectorButton;
